import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export const initializeUserStats = async (userId) => {
  console.log("Initializing userStats for:", userId);

  const userStatsRef = doc(db, "userStats", userId);
  const initialData = {
    points: {
      total: 0,
      daily: 0,
      streak: 0,
      lifetime: 0 // Track lifetime points even if spent
    },
    rank: {
      current: "Rookie",
      next: "Scout",
      progress: 0,
      history: [] // Optional: track past ranks with dates
    },
    multipliers: {
      nightowl: 0,
      weekend: 0,
      peakHours: 0,
      totalBonus: 0 // Total bonus points from multipliers
    },
    achievements: {
      // Tracking counters
      messagesSent: 0,
      conversationsStarted: 0,
      thumbsUpReceived: 0,
      parlayAdded: 0,
      underdogDiscussions: 0,
      nightOwlSessions: 0,
      
      // Achievement storage
      unlocked: {},  // Will store unlocked achievements
      streakMilestones: [],  // For tracking streaks
      
      // Stat tracking for achievements
      totalAchievements: 0,
      achievementPoints: 0
    },
    activity: {
      lastActiveDate: new Date().toISOString().split("T")[0],
      firstLoginDate: new Date().toISOString().split("T")[0],
      totalLogins: 1,
      totalActiveDays: 1
    },
    preferences: {
      notifications: {
        achievements: true,
        rankUps: true,
        streaks: true,
        pointsEarned: true
      }
    }
  };

  try {
    const userStatsDoc = await getDoc(userStatsRef);

    if (!userStatsDoc.exists()) {
      await setDoc(userStatsRef, initialData);
      console.log("UserStats document initialized for user:", userId);
    }
  } catch (error) {
    console.error("Error initializing userStats:", error);
  }
};